import { create } from '@bufbuild/protobuf';
import { ProtobufClient } from 'api/protobuf/protobuf-client';
import { WizardStepName } from 'data/ppoints/constants';
import { WizardStepRequestSchema } from '../../../../pb/requests/v1/wizard_step_request_pb';
import { WizardStepResponseSchema } from '../../../../pb/responses/v1/wizard_step_response_pb';
import { goBackendApi } from '../../../hooks/api/httpApi';
import { WizardStepModel } from '../models/WizardStepModel';

interface WizardStepsResponse {
    wizard_steps: WizardStepModel[];
}

const getStepsWithStatus = async (): Promise<WizardStepModel[]> => {
    const pbClient = new ProtobufClient(goBackendApi());
    return pbClient
        .getRequest(WizardStepResponseSchema, '/api/v1/wizard/steps')
        .then((response) => response.wizardSteps)
        .then((steps) => steps.map((s) => ({ ...s, name: s.name as WizardStepName })));
};

const markDone = async (stepName: string): Promise<void> => {
    const pbClient = new ProtobufClient(goBackendApi());
    return pbClient
        .postRequest(
            WizardStepRequestSchema,
            null,
            '/api/v1/wizard/step/mark-done',
            create(WizardStepRequestSchema, { stepName })
        )
        .then();
};

export default {
    getStepsWithStatus,
    markDone,
};
